import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { UrlPath } from "../../../config/routeConfig";
import { SBAComboBox, SBAMultiSelect } from "../../UiComponents/SBADropDown";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../../shared/topBar/TopBar";
import { sbaAxios } from "../../utils/sbaAxios";
import { getAllFamilies, getAssetAllocRpt, getFamilyMapping, getPortfolioByClientStmt, excelfiledownload, getQuarterNames, insertUpdateCashEntry, InsertAllocationSettings,getAllocationSettings, getCustomSettings, updateCustomSettings,getPDFDownload} from "../../../config/apiConfig";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import Settingicon from '../../asset/Images/settings.svg';
import download from '../../asset/assetList/images/download.svg';
import { Modal } from "react-bootstrap";
export const AssetAllocation = () => {
    const Level = [{ BreadCrumb: "Portfolio", Routes: `/${UrlPath.PortfolioList}` }, { BreadCrumb: "> Asset Allocation", Routes: `` }];
    const [families, setFamilies] = useState([]);
    const [selectedFamily, setSelectedFamily] = useState(null);
    const [portfolios, setPortfolios] = useState([]);
    const [selectedPortfolio, setSelectedPortfolio] = useState([]);
    const [clientStatements, setClientStatements] = useState([]);
    const [selectedClientStatement, setSelectedClientStatement] = useState(null);
    const gridRef=useRef();
    const includeCashGridRef=useRef();
    const assetPerType = [
        { value: "1", text: "Advised" },
        { value: "2", text: "All Performing" },
        { value: "3", text: "All Performing + Non-Performing" },
        { value: "4", text: "Advised + Non-Performing Cash" }
    ];
    const assetFutureTrans1 = [
        { value: "100", text: "NoAggregation" }
    ];
    const [selectedAssetAllocation, setSelectedAssetAllocation] = useState(assetPerType[0]);


    const [assetAggregationList, setAssetAggregationList] = useState(assetFutureTrans1);
    const [selectedAssetAggregation, setSelectedAssetAggregation] = useState(assetFutureTrans1[0]);

    const [selectedView, setSelectedView] = useState({ value: 2, text: "Monthly" });

    const lastMonthEndDate = new Date();
    lastMonthEndDate.setDate(0);

    const [asOfDate, setAsOfDate] = useState(lastMonthEndDate);
    const [aggDate,setAggDate]=useState(null);
    const [includeCashToAllocate, setIncludeCashToAllocate] = useState(false);
    const [currentCash, setCurrentCash] = useState(false);
    const [showcustom, SetShowcustom] = useState(false);
    const [IsFlow, SetIsFlow] = useState(false);
    const [includeCurrentMonthFlows, setIncludeCurrentMonthFlows] = useState(false);

    const [generatedTrackingColumns,setGeneratedTrackingColumns]=useState([]);
    const [generatedTrackingData,setGeneratedTrackingData]=useState([]);
    
    
    const [generatedSummaryColumns,setGeneratedSummaryColumns]=useState([]);
    const [generatedSummaryData,setGeneratedSummaryData]=useState([]);


    const [generatedCommitmentData,setGeneratedCommitmentData]=useState([]);

    const [fetchingData,setFetchingData]=useState({loading:false,Loaded:false});

    const [saveData,setSaveData]=useState([]);

    const [AssetAllocationType,setAssetAllocationType]=useState(null);
    const [futureDateTransaction,setFutureDateTransactions]=useState([]);
    const [showIncludeCashModal,setShowIncludeCashModal]=useState(false);
    const [includeCashPortfolios,setIncludeCashPortfolios]=useState([]);
    const includeCash=includeCashPortfolios.length>0;
    const [reportTitle, setReportTitle] = useState("");

    useEffect(()=>{
        setSelectedAssetAggregation(assetAggregationList[0]);
    },[selectedAssetAllocation]);

    useEffect(()=>{
        if(selectedPortfolio.length > 0){
            const title = selectedPortfolio.map((item) => item.PortfolioName).join(", ");
            setReportTitle(title);
        }
        else{
            setReportTitle("");
        }
    },[selectedPortfolio]);
    
    const includeCashGridColDef = [
        { field: '', checkboxSelection: true, showDisabledCheckboxes: true, maxWidth: 80 },
        { headerName: "Portfolio Name", field: "PortfolioName" },
    ];
    const styles = { minWidth: '19%' };
    const assetFutureTrans2 = [
        { value: "1", text: "PEAndRAOther" },
        { value: "100", text: "NoAggregation" }
    ];
    const assetFutureTrans3 = [
        { value: "2", text: "PEAndRAAll" },
        { value: "100", text: "NoAggregation" }
    ];
    const assetFutureTrans4 = [
        { value: "100", text: "NoAggregation" }
    ]
    useEffect(() => {
        document.title = "Asset Allocation";
        getFamilyList();
        getcustomsetting();
        getFutureTransactionDates(lastMonthEndDate).then(res=>setFutureDateTransactions(res)).catch(error=>setFutureDateTransactions([]))
    }, []);

    const getFamilyList = () => {
        try {
            sbaAxios({ url: getAllFamilies })
                .then(res => {
                    setFamilies(res);
                })
                .catch(error => {
                    console.log(error);
                    setFamilies([]);
                });
        } catch (error) {
            console.error('Error fetching families:', error);
        }
    };

    const getClientStatements = (familyId) => {
        try {
            sbaAxios({ url: getFamilyMapping + familyId })
                .then(res => {
                    const cslist = res.filter(item => item.EntityTypeId == 51).map(item => ({
                        ClientStatementId: item.EntityId,
                        ClientStatementName: item.EntityName
                    }));
                    setClientStatements(cslist);
                })
                .catch(error => {
                    console.log(error);
                    setClientStatements([]);
                });
        } catch (error) {
            console.error('Error fetching client statements:', error);
        }
    };
    // Get custom settings
    const getcustomsetting = () => {
        try {
            sbaAxios({ url: `${getCustomSettings}1030`})
                .then(response => {
                    if (response) {
                        const value=(JSON.parse(response.CustomSettingsValue));
                        SetIsFlow(val=>value.ShowFlows);
                    }
                })
                .catch(error => {
                    console.log(error);
                   
                });
        } catch (error) {
            console.error('Error fetching client statements:', error);
        }
    }

    const handleFamilyOnChange = (e) => {
        if (e.value) {
            setSelectedFamily(e.value);
            getClientStatements(e.value.FamilyId);
            setSelectedClientStatement(null);
            setSelectedPortfolio([]);
            setIncludeCashPortfolios([]);
            setPortfolios([]);
        }
    };

   const getAssetAllocationData = () => {

        const params = {
            portfolioLst: selectedPortfolio.map(item => item.PortfolioId).join(','),
            startDate: asOfDate ? new Date(asOfDate).toISOString().split('T')[0] : null,
            aType: selectedAssetAllocation?.value,
            aggType: selectedAssetAggregation?.value,
            clientStatementId: selectedClientStatement?.ClientStatementId,
            currentMonthFlow: includeCurrentMonthFlows,
            currentCash: currentCash,
            aggDate: aggDate ? aggDate.QuarterDate.split('T')[0] : null,
            includeCashToAllocate :includeCashToAllocate,
            otherportfolioLst: includeCashPortfolios.map(item => item.PortfolioId).join(',')
        };

        const queryParams = new URLSearchParams();
        const isValidDate = (dateStr) => {
            if (!dateStr) return false;
            const date = new Date(dateStr);
            return !isNaN(date.getTime());
        };
        const isValidPortfolioList = (list) => {
            return list && list.length > 0 && list.split(',').every(id => id.trim() !== "");
        };
        if (isValidPortfolioList(params.portfolioLst)) {
            queryParams.append("portfolioLst", params.portfolioLst);
        } else {
            return SBNotify({ Msg: "Please Select Any portfolio", type: "error" })
        }

        if (isValidDate(params.startDate)) {
            queryParams.append("startDate", params.startDate);
        } else {
            return SBNotify({ Msg: "Please Select Start Date", type: "error" })
        }

        for (const [key, value] of Object.entries(params)) {
            if (key !== "portfolioLst" && key !== "startDate" && value !== undefined && value !== null && value !== '') {
                queryParams.append(key, value.toString());
            }
        }
        setFetchingData(value=>({loading:true,Loaded:false}));
        const fullUrl = `${getAssetAllocRpt}?${queryParams.toString()}`;

        sbaAxios({ url: fullUrl })
            .then(response => {
                DataGenerator(response);
                setTimeout(() => {
                    setFetchingData(value=>({loading:false,Loaded:true}));
                }, 1000);
            })
            .catch(error => {
                console.error('API Error:', error);
                setTimeout(() => {
                    setFetchingData(value=>({loading:false,Loaded:false}));
                }, 1000);
                setGeneratedTrackingData([]);
                setGeneratedSummaryData([]);
                setGeneratedTrackingColumns([]);
                setGeneratedSummaryColumns([]);
            });
    };
 
    const prepareSaveData=(e)=>{
        try {
            debugger;
            const saveList=[];
            let cashId = 0;
          
            if (e?.column?.colId !== "MarketValue") {
                if (e?.colDef?.colType === "Monthly") {
                    const findedItem = e.data.Allocations.find(item => item.TransDate === e.colDef.keyValue);
                    if (e.data.CashIds != null && e.data.CashIds.length > 0) {
                        const date = moment(findedItem.TransDate).format("MM/DD/YYYY");
                    
                        const filterRes = e.data.CashIds.find(item =>
                           
                            moment(item.PostingDateFormatted, "MM/DD/YYYY").format("MM/DD/YYYY") === date
                        ) || null;
                    
                        if (filterRes != null) {
                            cashId = filterRes.CashId; 
                        }
                    }
                    if (findedItem || !findedItem) {
                        const data = {
                            cashId: cashId,
                            clientStatementId: selectedClientStatement.ClientStatementId,
                            portfolioId: e?.data?.PortfolioId,
                            portfolioName: "string",
                            abbr: "string",
                            assetId: e?.data?.AssetId,
                            assetName: "string",
                            amount: parseInt(e?.newValue || 0) || 0,
                            reportDate: moment(asOfDate).format("MM/DD/YYYY"),
                            postingDateFormatted: "MM/DD/YYYY",
                            postingDate: moment(findedItem?.TransDate || e.colDef.keyValue).format("MM/DD/YYYY"),
                            qtr: null,
                            yr: null,
                            isMktValue: e?.column?.colId === "MarketValue",
                            createdBy: 0,
                            modifiedBy: 0,
                            isUpdate: cashId!=0,
                            isEdited: true
                        };
                        saveList.push(data);
                    }
                } 
                else if (e?.colDef?.colType === "Quarterly") {
                    const [num1, num2] = e.colDef.keyValue.split(/\D+/);
                    const firstDayOfQuarter = new Date(parseFloat(num2), (parseFloat(num1) - 1) * 3, 1);
                    const findedItem = e.data.QtrAllocations.find(item => item.Qtr ===parseFloat(num1) && item.Yr===parseFloat(num2));
                    
                
                    if (e.data.CashIds != null && e.data.CashIds.length > 0) {
                        const date = moment(firstDayOfQuarter).format("MM/DD/YYYY");
                    
                        const filterRes = e.data.CashIds.find(item =>
                           
                            moment(item.PostingDateFormatted, "MM/DD/YYYY").format("MM/DD/YYYY") === date
                        ) || null;
                    
                        if (filterRes != null) {
                            cashId = filterRes.CashId; 
                        }
                    }
                    const data = {
                        cashId: cashId, // Ensure a valid single cashId
                        clientStatementId: selectedClientStatement.ClientStatementId,
                        portfolioId: e?.data?.PortfolioId,
                        portfolioName: "string",
                        abbr: "string",
                        assetId: e?.data?.AssetId,
                        assetName: "string",
                        amount: parseInt(e?.newValue || 0) || 0,
                        reportDate: moment(asOfDate).format("MM/DD/YYYY"),
                        // postingDateFormatted: "MM/DD/YYYY",
                        // postingDate: null,
                        qtr: num1,
                        yr: num2,
                        isMktValue: e?.column?.colId === "MarketValue",
                        createdBy: 0,
                        modifiedBy: 0,
                        isUpdate: cashId!=0,
                        isEdited: true
                    };
                    saveList.push(data);
                }
            }
            
            else 
            {
                if (e.data.CashIds != null && e.data.CashIds.length > 0) {
                    const date = moment(asOfDate).format("MM/DD/YYYY");
                
                    const filterRes = e.data.CashIds.find(item =>
                        item.IsMktValue === true &&
                        moment(item.PostingDateFormatted, "MM/DD/YYYY").format("MM/DD/YYYY") === date
                    ) || null;
                
                    if (filterRes != null) {
                        cashId = filterRes.CashId; 
                    }
                }
                const data = {
                    "cashId": cashId,
                    "clientStatementId": selectedClientStatement.ClientStatementId,
                    "portfolioId": e?.data?.PortfolioId,
                    "portfolioName": "string",
                    "abbr": "string",
                    "assetId": e?.data?.AssetId,
                    "assetName": "string",
                    "amount": parseInt(e?.newValue || 0) || 0,
                    "reportDate": moment(asOfDate).format("MM/DD/YYYY"),
                    "postingDateFormatted": "MM/DD/YYYY",
                    "postingDate": moment(asOfDate).format("MM/DD/YYYY"),
                    "qtr": null,
                    "yr": null,
                    "isMktValue": e?.column?.colId == "MarketValue",
                    "createdBy": 0,
                    "modifiedBy": 0,
                    "isUpdate":  cashId!=0,
                    "isEdited": true
                }
                saveList.push(data);
            };
             setSaveData(val => [...saveList, ...val])
        } catch (error) {

        }
    };
    const SaveAllocationData=()=>{
        try {
            if (saveData.length > 0) {
                sbaAxios({ url: insertUpdateCashEntry, data: saveData, method: "post" }).then(res => {
                    SBNotify({ Msg: "Allocation data Saved Successfully" });
                }).catch(error => {
                    SBNotify({ Msg: "Error While saving the Data , Please Contact Admin", type: "error" });
                })
            }
        } catch (error) {
            console.log("Error While Saving the Data")
        }
        finally {
           
            getAssetAllocationData();
            setSaveData([]);
        }
    }

    const SaveCustomize = () => {
        const saveData = {
            "componentId": 1030,
            "componentUserSettingId": 0,
            "userId": 0,
            "customSettingsValue": JSON.stringify({ShowFlows:IsFlow}),
            "isGrid": false
          };
          sbaAxios({ url: updateCustomSettings, method: 'post', data: saveData }).then(res=>{
            SBNotify({Msg:"Allocation Settings Saved Successfully"});
            SetShowcustom(false);
        }).catch(error=>{
            SBNotify({ Msg:"Error While Allocation Settings the Data , Please Contact Admin", type: "error" });
        })
    }
    const Excelexportdownload = () => {
      
        if(selectedPortfolio.length==0)
        {
            return SBNotify({ Msg: "Please Select Any portfolio", type: "error" })
        }
        else{
        const portfolioIds= selectedPortfolio.map(item => item.PortfolioId).join(',');
        const startDate = asOfDate ? new Date(asOfDate).toISOString().split('T')[0] : null
        const atype=selectedAssetAllocation?.value;
   
            const aggType=selectedAssetAggregation?.value;
            const clientStatementId=selectedClientStatement?.ClientStatementId;
           const  currentMonthFlow=includeCurrentMonthFlows;
           const  CurrentCash=currentCash;
            const aggDate1= aggDate ? aggDate.QuarterDate.split('T')[0] : null;
            const viewId=selectedView.value;
            const fileName = "Asset Allocation Report - " + selectedClientStatement?.ClientStatementName + "-" + startDate + ".xlsx";
            sbaAxios({
                url: `${excelfiledownload}?portfolioLst=${portfolioIds}&startDate=${startDate}&atype=${atype}&aggType=${aggType}&clientStatementId=${clientStatementId}&view=${viewId}&currentMonthFlow=${currentMonthFlow}&currentCash=${CurrentCash}&aggDate=${aggDate1}`,
                responseType: 'blob'
            }).then((response) => {
                var downloadLink = document.createElement('a');
                downloadLink.href = URL.createObjectURL(response);
                downloadLink.download = fileName;
                downloadLink.click();   
            })
        }
    };
 

    const pdfdownload = () => {
      
        if(selectedPortfolio.length==0)
        {
            return SBNotify({ Msg: "Please Select Any portfolio", type: "error" })
        }
        else{
        const portfolioIds= selectedPortfolio.map(item => item.PortfolioId).join(',');
        const startDate = asOfDate ? new Date(asOfDate).toISOString().split('T')[0] : null
        const atype=selectedAssetAllocation?.value;
   
            const aggType=selectedAssetAggregation?.value;
            const clientStatementId=selectedClientStatement?.ClientStatementId;
           const  currentMonthFlow=includeCurrentMonthFlows;
           const  CurrentCash=currentCash;
            const aggDate1= aggDate ? aggDate.QuarterDate.split('T')[0] : null;
            const viewId=selectedView.value;
            const fileName = "Asset Allocation Report - " + selectedClientStatement?.ClientStatementName + "-" + startDate + ".pdf";
            // sbaAxios({
            //     url: `${getPDFDownload}?familyId=${selectedFamily.FamilyId}&portfolioLst=${portfolioIds}&startDate=${startDate}&FutureTrans=${selectedView.value}&reportTitle=${reportTitle}&cash=true&commitment=true&summary=true&isAbbr=true&sFormat=PDF&atype=${atype}&aggType=${aggType}&csId=${clientStatementId}&IsAllFlows=${IsFlow}`,
            //     responseType: 'blob'
            // }).then((response) => {
            //     var downloadLink = document.createElement('a');
            //     downloadLink.href = URL.createObjectURL(response);
            //     downloadLink.download = fileName;
            //     downloadLink.click();   
            // })
            sbaAxios({
                url: `${getPDFDownload}?familyId=${selectedFamily.FamilyId}&portfolioLst=${portfolioIds}&startDate=${startDate}&FutureTrans=${selectedView.value}&reportTitle=${reportTitle}&cash=true&commitment=true&summary=true&isAbbr=true&sFormat=PDF&atype=${atype}&aggType=${aggType}&csId=${clientStatementId}&IsAllFlows=${IsFlow}`,
                responseType: "blob"
            }).then(data => {
                var file = new Blob([data], { type: 'application/pdf' });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);


            }).catch(() => {
                SBNotify({ Msg: 'Error generating pdf Report', type: 'error' })

            });
            
        }
    };
    const getPortfolioList = (value) => {
        try {
            sbaAxios({ url: getPortfolioByClientStmt + value }).then(res1 => {
                const res=res1.filter(
                    (obj, index, self) => index === self.findIndex(t => t.PortfolioId === obj.PortfolioId)
                  );
                setPortfolios(res);
                setSelectedPortfolio(val => res);
            }).catch(error => {
                setPortfolios([]);
            })
        } catch (error) {

        }
    }
    const handleAllocationonChange = (e) => {
        if (e.value) {
            const idField = parseInt(e.value.value);
            setSelectedAssetAllocation(e.value);
            setSelectedAssetAggregation(null);
            if (idField == 1)
                setAssetAggregationList(assetFutureTrans1);
            if (idField == 2)
                setAssetAggregationList(assetFutureTrans2);
            if (idField == 3)
                setAssetAggregationList(assetFutureTrans3);
            if (idField == 4)
                setAssetAggregationList(assetFutureTrans4);
        }
    };
    const DataGenerator=(response)=>{
        setAssetAllocationType(val=>selectedAssetAllocation);
        const CashToAllocateSection=[];
        const cashToAllocateRow=response?.InvestorTrackingSection.filter(a=>(a.AssetId==999999 && a.PortfolioId==999999));
        includeCashPortfolios.forEach(element=>{
            // const existingCashtoAllocate=response?.InvestorTrackingSection.find(item=>item.PortfolioId==element.PortfolioId && item.AssetId==47134)
            //  if(!existingCashtoAllocate)
            //  {
            //      cashToAllocateRow.AssetId=47134;
            //      cashToAllocateRow.PerfType=1;
            //      cashToAllocateRow.SecurityName='Cash To Allocate';
            //      cashToAllocateRow.ShortName=element.PortfolioId;
            //      includeCash && CashToAllocateSection.push(cashToAllocateRow);
            //  }
         })
        // const withOutCashToAllocate=.filter(item=>!(item.AssetId==47134)) || [];
        const formattedValues=[...response?.InvestorTrackingSection,...CashToAllocateSection].map(item => {
            const securityName =item.AssetId==47134? [item.StrategyName,'Cash To Allocate****'+item.ShortName]: item.AssetId > 0 
                ? [item.StrategyName, item.SecurityName+'****'+item.ShortName] 
                : [item.StrategyName, item.SecurityName].filter(Boolean);

                if(item.IsStrategy)
                {
                    const Allocation=[];
                    const subItemStrategy=response?.InvestorTrackingSection?.filter(sitem=>!sitem.IsStrategy && sitem.StrategyId==item.StrategyId) || [];
                    subItemStrategy.map(item=>{
                       Allocation.push(item.Allocations);
                    });
                    const formattedAllocation = [];

                    Allocation.forEach(aitem => {
                        aitem.forEach(saitem => {
                            const existingAllocation = formattedAllocation.find(item => item.TransDate === saitem.TransDate);
                            
                            if (existingAllocation) {
                                existingAllocation.TransAmt += saitem.TransAmt;
                                existingAllocation.TrackAmt += saitem.TrackAmt;
                            } else {
                                formattedAllocation.push({
                                    ...saitem,
                                    TransAmt: saitem.TransAmt,
                                    TrackAmt: saitem.TrackAmt
                                });
                            }
                        });
                    });
                    item.Allocations=[...formattedAllocation];
               }
                const monthlyData =    item?.Allocations?.length>0 ? item.Allocations.reduce((acc, alloc) => {
                acc[`Monthly_${alloc.TransDate}`] =  item.StrategyId==1001 ? alloc.TrackAmt:alloc.TransAmt;
                return acc;
            }, {}) : {};
            const QuaterlyData = item?.QtrAllocations?.length>0 ? item.QtrAllocations.reduce((acc, alloc) => {
                acc[`Q_${alloc.Qtr}_${alloc.Yr}`] = item.StrategyId==1001 ? alloc.TrackAmt:alloc.TransAmt;
                return acc;
            }, {}) : {};

            const marketVal=item.AssetId==47134 ? item?.CashIds?.find(item=>item.IsMktValue)?.Amount || 0 : item.MarketValue;
            return {
                ...item,
                SecurityName: securityName,
                MarketValue:marketVal,
                ...monthlyData,
                ...QuaterlyData
            };
        }).filter(a=>!(a.AssetId==999999 && a.PortfolioId==999999)).filter(item => includeCash || item.AssetId !== 47134).sort(item=>item.StrategySortOrder)
        || [];
        // const ceCollection = formattedValues.find(item => item.IsStrategy && item.StrategyId === 1001);
        // // const ultraFormattedValues = formattedValues.filter(item =>
        //   !ceCollection || item.AssetId !== 4713
        // );
        // console.log(ultraFormattedValues,'ultraFormattedValues')  
        setGeneratedTrackingData(val=>formattedValues);
        setGeneratedSummaryData(val=>response?.EntitySummarySection?.map(item => {
            const monthlyData = item?.Allocations?.length>0 ?  item.Allocations.reduce((acc, alloc) => {
                acc[`Monthly_${alloc.TransDate}`] = alloc.TransAmt;
                return acc;
            }, {}): {};
            const QuaterlyData =  item?.QtrAllocations?.length>0 ? item.QtrAllocations.reduce((acc, alloc) => {
                acc[`Q_${alloc.Qtr}_${alloc.Yr}`] = alloc.TransAmt;
                return acc;
            }, {}): {};
        
            return {
                ...item,
                ...monthlyData,
                ...QuaterlyData
            };
        }) || []);
        let AssetPerf=[];
        if (selectedAssetAllocation?.value == "100") {
            AssetPerf = response.InvestorTrackingSection?.filter((element)  => {
                return (element.PerfType == 1 || element.PerfType == 2 || element.PerfType == 3 || (element.PortfolioId == 0 && element.AssetId > 0 && element.StrategyId > 0));
            });
        }
        else if (selectedAssetAllocation?.value == "1") {

            AssetPerf = response.InvestorTrackingSection?.filter((element)  => {
                return (element.PerfType == 1 || (element.PortfolioId == 0 && element.AssetId > 0 && element.StrategyId > 0));
            });
        }
        else if (selectedAssetAllocation?.value == "2") {
            AssetPerf = response.InvestorTrackingSection?.filter((element)  => {
                return (element.PerfType == 1 || element.PerfType == 2 || (element.PortfolioId == 0 && element.AssetId > 0 && element.StrategyId > 0));
            });
        }
        else if (selectedAssetAllocation?.value == "3") {
            AssetPerf = response.InvestorTrackingSection?.filter((element) => {
                return (
                    element.PerfType == 1 ||
                    element.PerfType == 2 ||
                    element.PerfType == 3 ||
                    (element.PortfolioId == 0 && element.AssetId > 0 && element.StrategyId > 0)
                );
            });
        }
        
        else {
            AssetPerf = response.InvestorTrackingSection?.forEach((element,index) => {
                return (element.PerfType == 1 || (element.PortfolioId == 0 && element.AssetId > 0 && element.StrategyId > 0));
            });
        }


        setGeneratedCommitmentData(val=>response?.CommitmentSection || []);
        setGeneratedTrackingColumns(val=>trackingColDef(response.EntitySummarySection.length>0?response.EntitySummarySection[0].Allocations:"",response.EntitySummarySection.length>0?response.EntitySummarySection[0].QtrAllocations:"",AssetPerf));
        setGeneratedSummaryColumns(val => SummaryColDef(response.EntitySummarySection.length > 0 ? response.EntitySummarySection[0].Allocations : "", response.EntitySummarySection.length > 0 ? response.EntitySummarySection[0].QtrAllocations : "", AssetPerf));
    }
    const isChildEditable = (params) => {
        if (params.data.AssetId==0) return false; 
        return params?.data?.StrategyId==1001 && selectedAssetAllocation.value=='3' ;                  
    };
    const calculateFlow=(dataset,key,value,year)=>{
        const data=key=="TransDate" ? dataset?.data?.Allocations || [] : dataset?.data?.QtrAllocations || [] ;
        var obj= key=="TransDate" ? data.find(item=>item[key]==value) : data.find(item=>item[key]==value && item.Year==year) 
        return <> {obj && obj?.TrackAmt ? <div style={{
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            lineHeight: 'normal',
            textAlign:"center"
        }}>
            <span className="text-center">{getCurrencyFormat(obj?.TransAmt) || 0}</span>
            <hr className="m-0"/>
            <span className="text-center">{getCurrencyFormat(obj?.TrackAmt) || 0} <span>{obj?.InvTrackingStatusAbbr}</span></span>
        </div> : <></>}
        </> 
    }

    const generateMonthlyColumns = (months,dt) => {
        const columns = [];
        months && months?.forEach((element,index) => {
            let isvisible=true;
            if(dt?.length>0)
            {
                isvisible=dt?.[index]?.Allocations?.find(item => item.TransDate === element.TransDate)?.IsVisible || false;
            }
            columns.push({
                headerName: moment(element.TransDate).format("MM/DD/YY")   ,
                field: `Monthly_${element.TransDate}`,  
                cellStyle: { textAlign: "right" },
                minWidth: 120,
                sortable: true,
                filter: true,
                keyValue:element.TransDate,
                cellRenderer: (params) => IsFlow && params?.data?.StrategyId !== 1001 && params?.data?.SecurityName!== "Total" && !params?.data?.IsStrategy?  calculateFlow(params,"TransDate",element.TransDate) : getCurrencyFormat(params.value)  ,
                editable: (params) => isChildEditable(params),
                colType:"Monthly",
                hide: !isvisible
            })
            
        });
        if(aggDate)
        {
            columns.push({
                headerName: "Aggregate"  ,
                field: `AggregateValue`,  
                cellStyle: { textAlign: "right" },
                minWidth: 120,
                sortable: true,
                filter: true,
                valueFormatter: (params) => (params.value != null || params.value != 0)
                ? `$${params.value.toLocaleString()}`
                : "",
                editable: (params) => isChildEditable(params),
                colType:"Monthly",
            })
        }
        return columns;
    };

    const updateSettingsButton = () => {
        getcustomsetting();
        SetShowcustom(true);
    }

    const generateQuarterlyColumns = (QtrAllocations,dt) => {
        const columns = [];
        QtrAllocations && QtrAllocations?.forEach((element,index)=> {
            let isvisible=true;
            if(dt?.length>0)
            {
                isvisible=dt?.[index]?.QtrAllocations?.find(item => item.TransDate === element.TransDate)?.IsVisible || false;
            }
            columns.push({
                headerName: `Q${element.Qtr} ${element.Yr}`, 
                field: `Q_${element.Qtr}_${element.Yr}`,
                cellStyle: { textAlign: "right" },
                minWidth: 120,
                sortable: true,
                filter: true,
                keyValue:element.Qtr+"***"+element.Yr,
                cellRenderer: (params) => IsFlow && params.data.StrategyId !== 1001?  calculateFlow(params,"Qtr",element.Qtr,element.Year) : getCurrencyFormat(params.value)  ,
                editable: (params) => isChildEditable(params),
                colType: "Quarterly",
                hide: !isvisible
            })
        });
        if(aggDate)
        {
            columns.push({
                headerName: "Aggregate"  ,
                field: `AggregateValue`,  
                cellStyle: { textAlign: "right" },
                minWidth: 120,
                sortable: true,
                filter: true,
                valueFormatter: (params) => (params.value != null )
                ? `$${params.value.toLocaleString()}`
                : "",
                editable: (params) => isChildEditable(params),
                colType:"Quarterly",
            })
        }
        return columns;
    };
    const filterOptions=[
        {text:"Cash",value:1},
        {text:"Commitment",value:2},
        {text:"Summary by Entity",value:3},
        {text:"Status Abbr",value:4},
    ];
    const [selectedFilter,setSelectedFilter]=useState(filterOptions);
    const trackingColDef=(trackingMonths,QtrAllocations,AssetDt) => [
        {
            headerName: "Account",
            field: "ShortName",
          
            minWidth: 120,
            sortable: true,
            filter: true,
            colType:"Common",

        },
        {
            headerName: "MKT Value",
            field: "MarketValue",
            cellStyle: { textAlign: "right" },
            minWidth: 120,
            sortable: true,
            filter: "agNumberColumnFilter",
            colType:"Common",
            editable: (params) => isChildEditable(params),
            valueFormatter: (params) => {return getCurrencyFormat(params.value)}
        },
        {
            headerName: "% of Total",
            field: "BegPercentPortfolio",
            cellStyle: { textAlign: "right" },
            minWidth: 120,
            sortable: true,
            filter: "agNumberColumnFilter",
            colType:"Common",

            valueFormatter: (params) => params.value != null
                ? `${(params.value*100).toFixed(2)}%`
                : "",
        },
        {
            headerName: "Proposed Transaction",
            field: "ProposedTrans",
            cellStyle: { textAlign: "right" },
            minWidth: 150,
            sortable: true,
            filter: true,
            colType:"Common",

            valueFormatter: (params) => params.value != null
                ? `$${params.value.toLocaleString()}`
                : "",
        },
        {
            headerName: "Estimated Value after Rebalance",
            field: "EstimatedValueAfterRebalance",
            cellStyle: { textAlign: "right" },
            minWidth: 180,
            sortable: true,
            colType:"Common",

            filter: "agNumberColumnFilter",
            valueFormatter: (params) => params.value != null
                ? `$${params.value.toLocaleString()}`
                : "",
        },
        {
            headerName: "% of Total (Rebalanced)",
            field: "AdjustPercentPortfolio",
            cellStyle: { textAlign: "right" },
            minWidth: 150,
            sortable: true,
            colType:"Common",
            filter: "agNumberColumnFilter",
            valueFormatter: (params) => params.value != null
                ? `${(params.value*100).toFixed(2)}%`
                : "",
        },
        ...generateMonthlyColumns(trackingMonths,AssetDt),
        ...generateQuarterlyColumns(QtrAllocations,AssetDt)
    ];
    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true,
    };
    const flowChange = (e) => {

        SetIsFlow(e.target.checked);
    };
    const ExpandCollapseButton = () => {
        const [expanded, setExpanded] = useState(false);
        const onExpandAll = () => {
            setExpanded(true);
            gridRef.current.api.expandAll();
        };
        const onCollapseAll = () => {
            setExpanded(false);
            gridRef.current.api.collapseAll();
        };
        return (
            <div className="expand-collapse-button"> {!expanded ?
                <button onClick={onExpandAll} className="p-sm-btn">Expand All</button>
                :
                <button onClick={onCollapseAll} className="p-sm-btn">Collapse All</button>
            }
            </div>
        );
    };
    const autoGroupColumnDef = useMemo(() => {
        return {
            headerName: 'Asset Name',
            field: "SecurityName",
            minWidth: 300,
            cellRendererParams: {
                suppressCount: true,
            },
            headerComponent: ExpandCollapseButton,
            pinned: "left",
            editable: false,
            headerClass: "ag-grid-BR",
            colType:"Common",
            valueFormatter: (e) => { if (Array.isArray(e.value)) {
                const starIndex = e?.value[1]?.indexOf('***');
                if (starIndex > 0)
                  return e.value[1].slice(0, starIndex);
                else
                  return e.value[1];
                } 
                else return e.value }
        }
    }, []);
    const SummaryColDef=(summaryMonths,summaryQuaters)=>[{
        headerName: "Account Name",
        field: "PortfolioName",
        minWidth: 300,
        sortable: true,
        filter: true,
        colType:"Common",
    },
    {
        headerName: "Short Name",
        field: "Abbr",
        minWidth: 100,
        sortable: true,
        filter: true,
        colType:"Common",
    },
    {
        headerName: "MKT Value",
        field: "MarketValue",
        cellStyle: { textAlign: "right" },
        minWidth: 300,
        sortable: true,
        filter: "agNumberColumnFilter",
        colType:"Common",
        valueFormatter: (params) => {return getCurrencyFormat(params.value)}
    },
    {
        headerName: "% of Total",
        field: "PercentTotal",
        cellStyle: { textAlign: "right" },
        minWidth: 120,
        sortable: true,
        filter: "agNumberColumnFilter",
        colType:"Common",

        valueFormatter: (params) => params.value != null
            ? `${params.value.toFixed(2)}%`
            : "",
    },
    {
        headerName: "Proposed Transaction",
        field: "Transactions",
        cellStyle: { textAlign: "right" },
        minWidth: 150,
        sortable: true,
        filter: true,
        colType:"Common",

        valueFormatter: (params) => params.value != null
            ? `${params.value.toFixed(2)}%`
            : "",
    },
    ...generateMonthlyColumns(summaryMonths),
    ...generateQuarterlyColumns(summaryQuaters)
    ];
    const CommitmentColDef=[  {
        headerName: "Commitment Tracking",
        field: "AssetName",
        minWidth: 300,
        sortable: true,
        filter: true,
        colType:"Common",
    },
    {
        headerName: "Account",
        field: "Abbr",
        minWidth: 100,
        sortable: true,
        filter: true,
        colType:"Common",
    },
    {
        headerName: "Commitment",
        field: "Commitment",
        cellStyle: { textAlign: "right" },
        minWidth: 300,
        sortable: true,
        filter: "agNumberColumnFilter",
        colType:"Common",

        valueFormatter: (params) => params.value != null
            ? `$${params.value.toLocaleString()}`
                : "",
        }, {
            headerName: "Funded",
            field: "Funded",
            cellStyle: { textAlign: "right" },
            minWidth: 300,
            sortable: true,
            filter: "agNumberColumnFilter",
            colType: "Common",

            valueFormatter: (params) => params.value != null
                ? `$${params.value.toLocaleString()}`
                : "",
        },
        {
        headerName: "UnFunded",
        field: "Unfunded",
        cellStyle: { textAlign: "right" },
        minWidth: 300,
        sortable: true,
        filter: "agNumberColumnFilter",
        colType:"Common",

        valueFormatter: (params) => params.value != null
            ? `$${params.value.toLocaleString()}`
            : "",
    }
    ];
    const getDataPath = useCallback(data => data.SecurityName, []);
    return (
        <>
            <TopBar label="Asset Allocation" />
            <div className="mainContentData">
                <BreadCrumbs Levels={Level} />

                <div className="p-4">
                    <div className="border rounded p-3">
                        <div className="row justify-content-between my-2 gap-2">
                            <div className="col-auto" style={styles}>
                                <label className="mb-1 ms-2 fw-semibold fs-12 d-block">Family</label>
                                <SBAComboBox
                                    data={families}
                                    valueField="FamilyId"
                                    textField="FamilyName"
                                    className="w-75"
                                    onChange={handleFamilyOnChange}
                                    value={selectedFamily}
                                />
                            </div>

                            <div className="col-auto" style={styles}>
                                <label className="mb-1 ms-2 fw-semibold fs-12 d-block">Client Statement</label>
                                <SBAComboBox
                                    data={clientStatements}
                                    valueField="ClientStatementId"
                                    textField="ClientStatementName"
                                    className="w-75"
                                    value={selectedClientStatement}
                                    onChange={(e) => {
                                        getPortfolioList(e.value.ClientStatementId)
                                        setSelectedClientStatement(e.value)
                                        setIncludeCashPortfolios([]);
                                    }}
                                />
                            </div>

                            <div className="col-auto" style={styles}>
                                <label className="mb-1 ms-2 fw-semibold fs-12 d-block">Portfolio</label>
                                <SBAMultiSelect
                                    data={portfolios}
                                    valueField="PortfolioId"
                                    textField="PortfolioName"
                                    className="w-75"
                                    value={selectedPortfolio}
                                    onChange={(e) => setSelectedPortfolio(e.value)}
                                    tags={
                                        selectedPortfolio?.length > 0
                                            ? [{ text: `${selectedPortfolio.length} items selected`, data: [...selectedPortfolio] }]
                                            : []
                                    }
                                />
                            </div>

                            <div className="col-auto" style={styles}>
                                <label className="mb-1 ms-2 fw-semibold fs-12 d-block">As of Date</label>
                                <SBDatePicker
                                    value={moment(asOfDate)}
                                    format="MM/DD/YYYY"
                                    onChange={(e) => { setAsOfDate(e.toDate());getFutureTransactionDates(e.toDate()).then(res=>{setFutureDateTransactions(res);setAggDate(null)}).catch(error=>setFutureDateTransactions([]))}}
                                // onClose={() => { }}
                                />
                            </div>

                            <div className="col-auto" style={styles}>
                                <input
                                    type="checkbox"
                                    checked={includeCashToAllocate}
                                    onChange={() => {
                                        setIncludeCashToAllocate(!includeCashToAllocate); 
                                        if(!includeCash && portfolios.length>0)
                                        {
                                            setShowIncludeCashModal(true);
                                            setIncludeCashPortfolios([])
                                        }
                                        else
                                        {
                                            setIncludeCashPortfolios(val=>portfolios)
                                        }
                                    }}
                                />
                                <label className="ms-2 fw-semibold fs-12">Include Cash to Allocate</label>
                            </div>
                        </div>
                        <div className="row justify-content-between my-4 gap-2">
                            <div className="col-auto" style={styles}>
                                <label className="mb-1 ms-2 fw-semibold fs-12 d-block">Asset Allocation</label>
                                <SBAComboBox
                                    data={assetPerType}
                                    valueField="value"
                                    textField="text"
                                    className="w-75"
                                    value={selectedAssetAllocation}
                                    onChange={(e) => { handleAllocationonChange(e) }}
                                />
                            </div>

                            <div className="col-auto" style={styles}>
                                <label className="mb-1 ms-2 fw-semibold fs-12 d-block">Asset Aggregation</label>
                                <SBAComboBox
                                    data={assetAggregationList}
                                    valueField="value"
                                    textField="text"
                                    className="w-75"
                                    value={selectedAssetAggregation}
                                    onChange={(e) => setSelectedAssetAggregation(e.value)}
                                />
                            </div>
                            <div className="col-auto" style={styles}>
                                <label className="mb-1 ms-2 fw-semibold fs-12 d-block">Report Title</label>
                                <input type="text" className="form-control" value={reportTitle} onChange={(e)=> setReportTitle(e.target.value)} />
                            </div>
                            <div className="col-auto" style={styles}>
                                <label className="mb-1 ms-2 fw-semibold fs-12 d-block">Filter</label>
                                <SBAMultiSelect
                                    data={filterOptions}
                                    dataItemKey="value"
                                    textField="text"
                                    className="w-75"
                                    value={selectedFilter}
                                    tags={
                                        selectedFilter?.length > 0
                                            ? [{ text: `${selectedFilter.length} items selected`, data: [...selectedFilter] }]
                                            : []
                                    }
                                    onChange={(e) => { setSelectedFilter(e.value)}}
                                />
                            </div>

                            <div className="col-auto row-items d-flex justify-content-end gap-2" style={styles}>
                                <button className="p-sm-btn" onClick={()=>{getAssetAllocationData()}}>
                                    Generate
                                </button>
                             
                            </div>
                        </div>

                        <div className="row justify-content-between my-4 gap-2">
                            <div className="col-auto" style={styles}>
                                <label className="mb-1 ms-2 fw-semibold fs-12 d-block">View</label>
                                <SBAComboBox
                                
                                    data={[{ value: 1, text: "Quarterly" },{ value: 2, text: "Monthly" }]}
                                    value={selectedView}
                                    valueField="value"
                                    textField="text"
                                    className="w-75"
                                    onChange={(e) => setSelectedView(e.value)}
                                />
                            </div>

                            <div className="col-auto" style={styles}>
                                <input
                                    type="checkbox"
                                    checked={currentCash}
                                    onChange={() => setCurrentCash(!currentCash)}
                                />
                                <label className="ms-2 fw-semibold fs-12">Current Cash</label>
                            </div>
                            <div className="col-auto" style={styles}>
                                <input
                                    type="checkbox"
                                    checked={includeCurrentMonthFlows}
                                    onChange={() => setIncludeCurrentMonthFlows(!includeCurrentMonthFlows)}
                                />
                                <label className="ms-2 fw-semibold fs-12">Include Current month Flows</label>
                            </div>
                            <div className="col-auto" style={styles}>
                                <label className="mb-1 ms-2 fw-semibold fs-12 d-block">Future Transaction Aggregation</label>
                                <SBAComboBox
                                    data={futureDateTransaction}
                                    valueField="QuarterDate"
                                    textField="QuarterName"
                                    className="w-75"
                                    value={aggDate}
                                    onChange={(e) => {setAggDate(e.value)}}
                                />
                            </div>
                            <div className="col-auto" style={styles}></div>
                        </div>

                    </div>
                    {fetchingData.loading ? <><LoadingScreen /></> : <> {fetchingData.Loaded && 
                       <div className="" >
                            {selectedFilter.some(item=>item.value==1) && <div className="mt-4">
                                <div className="d-flex justify-content-between">
                                <p class="fw-medium mx-2">{AssetAllocationType?.text} </p>
                                <div className="d-flex">
                            {AssetAllocationType?.value=='3' && <>

                               <button className="p-sm-btn mx-1" onClick={() => { SaveAllocationData() }}>
                                    {/* <img src={download} alt="Excel" /> */}
                                    Save</button>
                            
                            </>}


                                    <button className="p-sm-btn mx-1 row-items" onClick={updateSettingsButton}>
                                        <img
                                            src={Settingicon}
                                            alt=""
                                            className="WhiteImage"
                                        />
                                    </button>
                           
                                    <button className="p-sm-btn mx-1" onClick={()=>{pdfdownload()}}>
                                   
                                    PDF Download</button>
                           
                                    <button className="p-sm-btn mx-1" onClick={()=>{Excelexportdownload()}}>
                                 
                                    Excel Download</button>
                                </div>
                                
                                </div>
                                <div
                                    className="ag-theme-alpine pt-0"
                                    style={{ width: "100%", height: "500px" }}
                                >
                                    <AgGridReact
                                        ref={gridRef}
                                        treeData={true}
                                        columnDefs={generatedTrackingColumns.filter(item => (item.colType == selectedView.text || item.colType == "Common"))}
                                        rowData={generatedTrackingData}
                                        defaultColDef={defaultColDef}
                                        autoGroupColumnDef={autoGroupColumnDef}
                                        getDataPath={getDataPath}
                                        className="my-4"
                                        singleClickEdit={true}
                                        stopEditingWhenCellsLoseFocus={true}  
                                        onCellValueChanged={(e)=>{prepareSaveData(e)}}
                                    ></AgGridReact>
                                </div>
                            </div>
                            }
                            {selectedFilter.some(item=>item.value==2)  && <div className="mt-4">
                                <p class="fw-medium  mx-2">Commitment Tracking</p>
                                <div
                                    className="pt-0 ag-theme-alpine"
                                    style={{ width: "100%", height: "300px" }}
                                >
                                    <AgGridReact
                                        columnDefs={CommitmentColDef}
                                        rowData={generatedCommitmentData}
                                        defaultColDef={defaultColDef}
                                        className="my-4"
                                    ></AgGridReact>
                                </div>
                            </div>
                            }
                                {selectedFilter.some(item=>item.value==3)  && <div className="mt-4">
                                <p class="fw-medium  mx-2">Summary by Entity</p>
                                <div
                                    className="pt-0 ag-theme-alpine"
                                    style={{ width: "100%", height: "300px" }}
                                >
                                    <AgGridReact
                                        columnDefs={generatedSummaryColumns.filter(item => (item.colType == selectedView.text || item.colType == "Common"))}
                                        rowData={generatedSummaryData}
                                        defaultColDef={defaultColDef}
                                        className="my-4"
                                    ></AgGridReact>
                                </div>
                            </div>
                            }
                        </div>}
                        </>
                    }
                </div>
            </div>
            <Modal show={showIncludeCashModal}>
        <Modal.Header
          closeButton
          onClick={() => {
            setShowIncludeCashModal(false);
          }}
        >
          <Modal.Title>
          Cash to Allocate
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
         <div className="ag-theme-alpine">
                        <AgGridReact
                            ref={includeCashGridRef}
                            columnDefs={includeCashGridColDef}
                            rowData={portfolios}
                            defaultColDef={defaultColDef}
                            onRowSelected={(event)=>{
                                if (event.node.isSelected()) {
                                    setIncludeCashPortfolios(val=>[...val,event.data])
                                } else {
                                    setIncludeCashPortfolios(val=>val.filter(item=>item.PortfolioId!=event.data.PortfolioId))
                                }
                            }}
                            rowSelection="multiple"
                            className="my-4"
                        ></AgGridReact>
         </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="s-sm-btn mx-1"
            onClick={() => {
                setShowIncludeCashModal(false);
                setIncludeCashToAllocate(false);
            }}
          >
            Cancel
          </button>
          <button
            className="p-sm-btn mx-1"
            onClick={()=>{  
                if(includeCashPortfolios.length === 0){
                    setIncludeCashToAllocate(false);
                }
                else{
                    getAssetAllocationData();
                }
                setShowIncludeCashModal(false);
            }}          
            >
            Ok
          </button>
        </Modal.Footer>
            </Modal>
            <Modal show={showcustom}>
                <Modal.Header
                    closeButton
                    onClick={() => {
                        SetShowcustom(false);
                    }}
                >
                    <Modal.Title>Customize View Settings</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-4">
                        <label>  <input type="checkbox" checked={IsFlow} onChange={(e) => { flowChange(e) }} /> Show All Flows</label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="s-sm-btn mx-1"
                        onClick={() => {
                            SetShowcustom(false);
                        }}
                    >
                        Cancel
                     </button>
                    <button
                        className="p-sm-btn mx-1"
                        onClick={SaveCustomize}
                    >
                        Save
                   </button>
                </Modal.Footer>
            </Modal>


            <ToastContainer />
        </>
    );
};

const getFutureTransactionDates = async(reportDate = null) => {
    try {
        const futureTransactionDates=await sbaAxios({url:getQuarterNames+"?ReportDate="+reportDate.toISOString()});
        return futureTransactionDates;
    } catch (error) {
        console.log(error,'Error Occured in getFutureTransactionDates')
        return[];
    }
};
export const getCurrencyFormat = (number, decimalnumber = 2, currencyCode = 'USD', locale = 'en-US') => {
    try {
      if (number == null || Number(number) === 0 || isNaN(Number(number))) {
        return '';
      }
      const decimalPlaces = Math.max(0, parseInt(decimalnumber, 10) || 0);
  
      const formattedCurrency = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      }).format(Number(number));
  
      return formattedCurrency;
    } catch (error) {
      console.error('Error formatting currency:', error);
      return '';
    }
  };
  